<script setup lang="ts">
  import { useSwitchAccount } from "@/lib/shared/useSwitchAccount.ts"
  import { useBreakpoint } from "@/lib/useBreakpoint.ts"
  import { computed } from "vue"
  import SwitchAccountModal from "@/components/dialogs/SwitchAccountModal.vue"
  import SwitchAccountSheet from "@/components/SwitchAccountSheet.vue"
  import Alert from "@/components/ui/alert/Alert.vue"
  import { Button } from "@/components/ui/button"

  const {
    accountIDs,
    currentAccountID,
    isSwitchAccountOpen,
    openSwitchAccount,
  } = useSwitchAccount()

  const isTablet = useBreakpoint("sm")

  const hasAnotherAccount = computed(() =>
    accountIDs.value.some(
      (accountID) =>
        currentAccountID.value !== undefined &&
        accountID !== currentAccountID.value,
    ),
  )

  const SwitchAccountComponent = computed(() =>
    isTablet.value ? SwitchAccountModal : SwitchAccountSheet,
  )
</script>

<template>
  <Alert
    variant="error"
    data-testid="closed-account-alert"
    class="mt-4 px-6 md:mt-0"
  >
    Your account is closed

    <template v-if="hasAnotherAccount" #action>
      <div class="ml-3 mt-3 self-end sm:mt-0 sm:self-center">
        <Button
          variant="text"
          size="md"
          icon="ArrowRight"
          class="text-inherit hover:bg-transparent active:bg-transparent"
          @click="openSwitchAccount"
        >
          Switch account
        </Button>

        <component
          :is="SwitchAccountComponent"
          v-model:open="isSwitchAccountOpen"
        />
      </div>
    </template>
  </Alert>
</template>
